import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { DeleteSvg, EditSvg, SwitchOffSvg, SwitchOnSvg } from "../../../assets/svg/index.js";
import MainDatatable from "../../../components/common/MainDatatable.jsx";
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import * as SancharActions from '../../../redux/actions/sancharAction';
import { api_urls } from "../../../utils/api-urls/index.js";

const Live = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { liveData } = useSelector(state => state.sancharReducer);

    //* DataTable Columns
    const videoclipColumns = [
        { name: 'S.No.', selector: row => liveData.indexOf(row) + 1, width: '80px' },
        { name: 'Title', selector: row => row?.Title },
        { name: 'Image', cell: row => <img src={row?.image && api_urls + row?.image} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
        { name: 'Link', selector: row => <Link target="_blank" to={row?.Link} >Link</Link> },
        { name: 'Trending', selector: row => row?.Trending == 'true' ? 'Trending' : 'Not Trending' },
        // { name: 'Status', selector: row => <div onClick={() => dispatch(SancharActions.changeVideoclipStatus({ videoId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
                <div onClick={() => navigate('/live/edit-live', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
                <div onClick={() => dispatch(SancharActions?.deleteLive({ id: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
            </div>,
            width: "180px"
        },
    ];

    useEffect(() => {
        //! Dispatching API for Getting Live
        dispatch(SancharActions.getLive());
    }, []);

    return (
        <>
            <MainDatatable data={liveData} columns={videoclipColumns} title={'Live'} url={'/live/add-live'} />


        </>
    );
};

export default Live;